export default [{
  path: '/storeDetail',
  name: 'storeDetail',
  component: () => import('@/views/home/store-detail/index'),
}]
